function getSlider(section,container,itemContainer,item) {
    const sliderSection = document.querySelector('.'+section);
    const slider = sliderSection.querySelector('.'+itemContainer);
    
    const sliderContainer = sliderSection.querySelector('.'+container);
    const sliderItem = sliderSection.querySelector('.'+item);
    const nextBtn = sliderSection.querySelector('.next');
    const prevBtn = sliderSection.querySelector('.prev');
    const itemWidth = sliderItem.clientWidth;
    const totalItemWidth = itemWidth +20;
    //////////////////////////////////
    let scrollAmount = 0;
    let maxScrollAmount = slider.scrollWidth - slider.clientWidth;
    let isDragging = false;
    let startPosition = 0;
    let deltaX = 0;
    /////прокручивание мышкой
    slider.addEventListener('mousedown', (event) => {
        event.preventDefault();
        isDragging = true;
        startPosition = event.clientX - slider.offsetLeft;
        slider.style.cursor = 'grabbing';
    });

    slider.addEventListener('mousemove', (event) => {
        if (isDragging) {
            const currentPosition = event.clientX - slider.offsetLeft;
            deltaX = startPosition - currentPosition;
            slider.scrollLeft += deltaX*20;
            startPosition = currentPosition;
        }
    });

    slider.addEventListener('mouseup', () => {
        isDragging = false;
        slider.style.cursor = 'grab';
    });
    ;
    slider.addEventListener('mouseleave', () => {
        isDragging = false;
        slider.style.cursor = 'grab';
    });
    ////// прокрут кнопками
    nextBtn.addEventListener('click', () => {
        if(scrollAmount >= maxScrollAmount){
            return
        }
        else {
            scrollAmount += totalItemWidth;
        slider.scrollLeft = scrollAmount;
        }
    });

    prevBtn.addEventListener('click', () => {
       if(scrollAmount<=0) {
        return
       }
       else {
        scrollAmount -= totalItemWidth;
        slider.scrollLeft = scrollAmount;
       }
    });
    ///////////////добавление точке
    const carouselLenght = slider.querySelectorAll('.'+item).length;
        // stile.style.height = carousel.childNodes[0].offsetHeight + 10 +'px';
        ///////создаем контейнер точек
        let dotContainer = document.createElement('div');
        dotContainer.classList.add('dot-container');
                //////создаем обертку для точек
        let dotWrapper = document.createElement("div");
        dotWrapper.classList.add('dot-wrapper');
        dotContainer.appendChild(dotWrapper);
        slider.closest('.myCarousel-wrapper').appendChild(dotContainer);
        ///////цикл для добавления точек
        for(let i=0; i < carouselLenght; i++) {
            let dot = document.createElement("div");
            dot.classList.add('dot');
            dotWrapper.appendChild(dot);
        }
        dotWrapper.style.width = (20* carouselLenght)-12 +'px'; 
        let current = 0;
        let childnodes = dotWrapper.querySelectorAll('.dot');
        childnodes[0].classList.add('dot-active');
        slider.addEventListener('scroll', function() {
            let width = sliderItem.offsetWidth;
            let scrolling = slider.scrollLeft +30;
            current = Math.round(scrolling / width);
            if(!childnodes[current].classList.contains('dot-active')) {
                childnodes.forEach(node=>{
                    node.classList.remove('dot-active');
                })
                childnodes[current].classList.add('dot-active');
            }
            else {
                return
            }
            
        })
}
module.exports = getSlider;